import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CalendarIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.15 2.85H15.2V0.95C15.2 0.698044 15.0999 0.456408 14.9218 0.278249C14.7436 0.100089 14.502 0 14.25 0C13.998 0 13.7564 0.100089 13.5782 0.278249C13.4001 0.456408 13.3 0.698044 13.3 0.95V2.85H5.7V0.95C5.7 0.698044 5.59991 0.456408 5.42175 0.278249C5.24359 0.100089 5.00196 0 4.75 0C4.49804 0 4.25641 0.100089 4.07825 0.278249C3.90009 0.456408 3.8 0.698044 3.8 0.95V2.85H2.85C2.09413 2.85 1.36922 3.15027 0.834746 3.68475C0.300267 4.21922 0 4.94413 0 5.7V6.65H19V5.7C19 4.94413 18.6997 4.21922 18.1653 3.68475C17.6308 3.15027 16.9059 2.85 16.15 2.85Z"
        fill="currentColor"
      />
      <path
        d="M0 16.1498C0 16.9057 0.300267 17.6306 0.834746 18.1651C1.36922 18.6995 2.09413 18.9998 2.85 18.9998H16.15C16.9059 18.9998 17.6308 18.6995 18.1653 18.1651C18.6997 17.6306 19 16.9057 19 16.1498V8.5498H0V16.1498Z"
        fill="currentColor"
      />
    </svg>
  )
})

CalendarIcon.displayName = 'CalendarIcon'
